// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  getCollapsibleButton,
  getVisibleItemCount,
} from '../../store/componentSettings/selectors/listSettings';
import List from './list';
import type { StateProps, Props as ComponentProps, CollapsibleButtonText } from './types';

type OwnProps = {|
  ...ComponentProps,
  collapsibleButtonTextOverride?: CollapsibleButtonText,
|};

type Props = OwnProps & StateProps;

const getCollapsibleText = (text?: CollapsibleButtonText): ?CollapsibleButtonText => {
  if (text && text.collapsed && text.expanded) {
    return text;
  }
  return null;
};

const ListContainer = ({
  collapsibleButtonTextOverride = {
    expanded: '',
    collapsed: '',
  },
  collapsibleButtonText,
  border,
  ...props
}: Props) => (
  <List
    buttonText={getCollapsibleText(collapsibleButtonTextOverride) || collapsibleButtonText}
    border={border}
    {...props}
  />
);

ListContainer.defaultProps = {
  collapsibleButtonTextOverride: {
    expanded: '',
    collapsed: '',
  },
};

const mapStateToProps = (state): StateProps => ({
  collapsibleButtonText: getCollapsibleButton(state),
  visibleItemCount: getVisibleItemCount(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ListContainer);
